<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <div class="status-tag">
          <el-tag effect="dark" size="mini" :type="row.status">
            {{ row.v_status }}
          </el-tag>
        </div>
      </template>
      <template v-slot:deviationQty="{ row }">
        <span :style="{ color: row.deviationQty < 0 ? '#F72713' : '#2BA745' }">
          {{ row.deviationQty }}
        </span>
      </template>
      <template v-slot:deviationSpec="{ row }">
        <div>{{ row.spec }}{{ row.specUnit }}</div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createTime }}</div>
      </template>
      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyTime }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    isShowLaborPrice: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    tableColumns() {
      return tableColumns(this,this.isShowLaborPrice)
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { pendingGoodsPackageWorklogCode, pendingGoodsCode } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pendingGoodsPackageWorklogCode,
            pendingGoodsCode,
            menuType,
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'audit':
          this.audit(data)
          break
      }
    },
    async del({ pendingGoodsPackageWorklogCode }) {
      const confirm = await this.$confirm(
        '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .orderTechPricingDelApi({ pendingGoodsPackageWorklogCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async audit({ pendingGoodsPackageWorklogCode }) {
      const confirm = await this.$confirm(
        this.$l('label_audit') || '是否审核确认该工价单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .orderTechPricingAuditApi({ pendingGoodsPackageWorklogCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('审核确认失败！')
        return
      }
      this.$message({
        message: '审核确认成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  font-size: 12px;
  .el-tag--N {
    color: #91939a;
    background-color: #f4f4f5;
    border: #91939a;
  }

  .el-tag--U {
    color: #70ce46;
    background-color: #f6ffed;
    border: #b7eb8f;
  }

  .el-tag--S {
    color: #007bff;
    background-color: #e9f3ff;
    border: #007bff;
  }

  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
}
</style>
